var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6514 7.10498C20.2682 7.19663 22.6316 8.26984 24.3902 9.97281L30.3214 5.9031C27.2216 2.36445 22.7032 0.103461 17.6514 0V7.10498Z",
    fill: "#273E52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9298 0V7.10383C16.5688 7.11828 16.2079 7.1471 15.8541 7.20491L15.0456 4.9308C14.9156 4.57705 14.5907 4.34607 14.2153 4.34607C13.9626 4.34607 13.7244 4.44707 13.5584 4.62755C13.3923 4.80803 13.3129 5.04633 13.3273 5.29176L13.5078 7.82577C12.9158 8.05675 12.3527 8.34563 11.8184 8.68492L7.62402 2.9527C10.288 1.14785 13.4861 0.072176 16.9298 0Z",
    fill: "#273E52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03074 3.35938C3.01303 6.32106 0.316869 10.9734 0.000845909 16.267C-0.0155457 16.5406 0.208473 16.7723 0.482548 16.7723H6.64994C6.89785 16.7723 7.09719 16.5809 7.12072 16.3341C7.40405 13.3687 8.9572 10.7738 11.2249 9.09195L7.03074 3.35938Z",
    fill: "#273E52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7863 6.46875L24.9004 10.5075C26.3176 12.0902 27.2529 14.1139 27.4665 16.3481C27.49 16.5948 27.6893 16.7862 27.9372 16.7862H34.0975C34.3715 16.7862 34.5956 16.5545 34.5793 16.281C34.3584 12.5771 32.9737 9.18624 30.7863 6.46875Z",
    fill: "#273E52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4965 16.5693C19.8181 18.1035 18.8324 19.612 17.2906 19.9351C15.7487 20.2583 14.2404 19.2725 13.9188 17.7382C13.7097 16.7406 14.0474 15.7546 14.7381 15.0971L14.0471 5.2447C14.0339 5.05596 14.299 5.00039 14.3627 5.17856L17.6857 14.4793C18.5822 14.8042 19.2874 15.5716 19.4965 16.5693Z",
    fill: "#273E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageGrey);
export default __webpack_public_path__ + "static/media/usage-grey.4c69262ac7501cbd0b2dbc343c5d141e.svg";
export { ForwardRef as ReactComponent };